/* eslint-disable no-unused-vars */
import React, { useContext, useRef, useEffect } from 'react';
import { Search, DropDownList } from 'components';
import { Search as SmallSearchIcon } from 'assets/icons';
import { useSignal, useSignalEffect } from '@preact/signals-react';
import { ManageCampaignsContext } from 'contexts';

const createAppsToShow = (currentCampaignList, allCampaigns) => {
  let appList = [];
  const campaignListToCount = currentCampaignList.length ? currentCampaignList : allCampaigns;

  campaignListToCount.forEach(
    ({ pba_number, image_url, packageName = 'mockPackageName', app }, index) => {
      const appIsAlreadyContained = appList.find((appData) => appData.pba_number === pba_number);
      if (!appIsAlreadyContained) {
        const containedIn = allCampaigns
          .filter((campaign) => campaign.pba_number === pba_number)
          .map((campaignData) => campaignData._campaignid);
        appList.push({
          app,
          pba_number,
          image_url,
          packageName,
          isApp: true,
          containedIn,
          index,
        });
      }
    },
  );
  return appList;
};

const searchCampaignAdnAppsFunc = (campaignsData, searchValue) => {
  if (!searchValue) {
    const indexedCampaignsData = structuredClone(
      campaignsData.map((campData, index) => ({ ...campData, index })),
    );
    const appList = createAppsToShow([], campaignsData);
    return { campaigns: indexedCampaignsData, applications: appList };
  }
  const currentCampaignList = campaignsData.filter((campData) => {
    if (campData.campaign?.toLowerCase().includes(searchValue.toLowerCase())) return campData;
    if (campData.app?.toLowerCase().includes(searchValue.toLowerCase())) return campData;
    if (campData.pba_number?.toString().toLowerCase().includes(searchValue.toLowerCase()))
      return campData;
    if (campData._campaignid?.toString().toLowerCase().includes(searchValue.toLowerCase()))
      return campData;
  });
  if (!currentCampaignList.length) {
    return { campaigns: [], applications: [] };
  }
  const indexedCampaignsData = structuredClone(
    currentCampaignList.map((campData, index) => ({ ...campData, index })),
  );
  const appList = createAppsToShow(indexedCampaignsData, campaignsData);
  return { campaigns: indexedCampaignsData, applications: appList };
};

export const DropDownSearch = () => {
  const filteredCampaignsAndApps$ = useSignal(null);

  const { campaignData$, rowData, searchValue$, showDropDown$, originalTableData } =
    useContext(ManageCampaignsContext);

  const searchRef = useRef(null);

  useEffect(() => {
    filteredCampaignsAndApps$.value = searchCampaignAdnAppsFunc(
      campaignData$.value.campaignsData,
      searchValue$.value,
    );
  }, [searchValue$.value, campaignData$.value.campaignsData]);

  const handleClickToInputBox = () => {
    showDropDown$.value = true;
  };
  return (
    <div style={{ width: '100%', position: 'relative' }}>
      <Search
        onFocus={handleClickToInputBox}
        ref={searchRef}
        id='manageCampaignSearch'
        onChange={(e) => (searchValue$.value = e.target.value)}
        value={searchValue$?.value}
        placeholder='Search Campaign'
        rightIconOnClick={() => (searchValue$.value = '')}
        Icon={SmallSearchIcon}
      />
      <DropDownList
        filteredCampaignsAndApps$={filteredCampaignsAndApps$}
        showDropDown$={showDropDown$}
        searchRef={searchRef}
        searchValue$={searchValue$}
      />
    </div>
  );
};
